/*
 * @Author: yeyimei
 * @Date: 2023-10-07 16:11:48
 * @LastEditTime: 2023-11-27 18:02:21
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\store\modules\movice.js
 */
import { getMovieCityListApi } from "@/utils/film"
import {
  getStorage,
  getAppIdStorage,
  setAppIdStorage,
  getSession,
  setSession,
} from "@/libs/storage.js"
let appId = getStorage("appId") || ""
const movice = {
  state: {
    moviceCityObj: getSession("moviceCityObj") || null,
  },
  mutations: {
    setMoviceCityObj(state, val) {
      state.moviceCityObj = val
      setSession("moviceCityObj", state.moviceCityObj)
    },
  },

  getters: {
    getMoviceCityObj(state) {
      return state.moviceCityObj
    },
  },

  actions: {
    // 获取首页数据
    async getMoviceCityListMethod({ state, commit }) {
      try {
        let infos_storage = getAppIdStorage(appId)
        let city = infos_storage.selectCity.city
        const RES = await getMovieCityListApi()
        const { data, code } = RES.data
        if (code === 200) {
          let newArr = Object.values(data)
          newArr.forEach((item) => {
            item.forEach((e) => {
              if (city.indexOf(e.city) >= 0) {
                
                let newObj = { ...state.moviceCityObj, ...e }
                console.log("Vuex 获取首页数据", e)
                commit("setMoviceCityObj", newObj)
              }
            })
          })
        }
      } catch (error) {
        console.log("Vuex 获取首页数据失败", error)
        return error
      }
    },
  },
}

export default movice
